export const MODAL_OPEN_BUTTON_TEXT = 'Remove Strike';
export const STINTER_PROFILE_REF_INPUT_LABEL = 'Stinter Profile Ref';
export const REASON_INPUT_LABEL = 'Number of strikes.';
export const MODAL_TITLE = 'Remove Strike';
export const CREATE_REDEMPTION_SUCCESS_MSG = 'Redemption successfully created.';
export const CREATE_REDEMPTION_FAILED_MSG =
  'There was a problem removing the strike.';
